export default __webpack_public_path__ + "static/media/wchss-pict-1.cfac3d37.png";